import React from 'react'
import ReactDOM from 'react-dom/client'

import {
  ProductsDetail,
  ProductsList,
  type ProductsListProps,
  type ProductsDetailProps
} from '../pages/products'
import '../pages/products/products.less'
import { getInitData } from './public/getInitData'

const { routerName } = getInitData()
if (routerName === 'list') {
  const rootEl = document.getElementById('root')
  if (rootEl) {
    const props = getInitData<ProductsListProps>()
    const root = ReactDOM.createRoot(rootEl)
    root.render(
      <React.StrictMode>
        <ProductsList {...props} />
      </React.StrictMode>
    )
  }
}
if (routerName === 'detail') {
  const rootEl = document.getElementById('root')
  if (rootEl) {
    const root = ReactDOM.createRoot(rootEl)
    const props = getInitData<ProductsDetailProps>()
    root.render(
      <React.StrictMode>
        <ProductsDetail {...props} />
      </React.StrictMode>
    )
  }
}
